import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreLink?: string;
  moreLabel?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreLink,
  moreLabel = '查看更多',
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5 md:mb-6">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider text-accent-600 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-1.5 font-display text-2xl md:text-3xl font-bold text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="mt-1.5 text-sm text-foreground-500 max-w-2xl">{description}</p>
        )}
      </div>
      {action}
      {!action && moreLink && (
        <Link
          to={moreLink}
          className="group inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}